export default __webpack_public_path__ + "static/media/a5.d287da00.JPG";